import type { UniversalModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import AppearanceModifier from "./base/AppearanceModifier";
import { AssetModifier } from "./base/AssetModifier";
import BorderModifier from "./base/BorderModifier";
import HeightModifier from "./base/HeightModifier";
import MarginModifierComponent from "./base/MarginModifier";
import ObjectFitModifier from "./base/ObjectFitModifier";
import ShadowModifierComponent from "./base/ShadowModifier";
import WidthModifier from "./base/WidthModifier";
import ModifierLayout from "./ModifierLayout";
import { useDefaultSelectedElementDesignation } from "./store/ModifiersStoreContext";

interface VideoModifierBlockProps {
  onModifiersValueChange: (
    modifiers: UniversalModifierValue[],
    stableElementId: string,
  ) => void;
}

const VideoModifierBlock: React.FC<VideoModifierBlockProps> = ({
  onModifiersValueChange,
}) => {
  const defaultDesignation = useDefaultSelectedElementDesignation();

  if (!defaultDesignation) {
    return null;
  }

  const sections = [
    {
      rows: [
        {
          title: "Media",
          component: (
            <AssetModifier
              onAssetChange={(assetSource) => {
                onModifiersValueChange(
                  [{ type: "asset", value: assetSource ?? "" }],
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Width",
          component: (
            <WidthModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
        {
          title: "Height",
          component: (
            <HeightModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
        {
          title: "Object Fit",
          component: (
            <ObjectFitModifier
              onChange={(modifier) => {
                onModifiersValueChange(
                  [modifier],
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Margin",
          component: (
            <MarginModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Border",
          component: (
            <BorderModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
        {
          title: "Appearance",
          component: (
            <AppearanceModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
        {
          title: "Shadow",
          component: (
            <ShadowModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
  ];

  return (
    <ModifierLayout
      sections={sections}
      onModifiersValueChange={onModifiersValueChange}
    />
  );
};

export default VideoModifierBlock;
